import { FormatStringByWordLength } from "../../../shared/scripts/array-functions";

export class ProjectForm {

    FormId: number;
    Email: string;
    StatusId: number;
    SubmissionDate: string;
    StartDate: string;
    EndDate: string;
    InteractInvolved: boolean;
    InteractDetails: string;
    Aims: string;
    Description: string;
    StakeholderEngagement: string;
    Title: string;


    initialize(): void {
        this.Email = '';
    }
}

export class ProjectFile {
    id: string;
    icon: string;
    link: string;
    text: string;
}

export class ProjectFormHub {
    FormId: number;
    HubId: number;
    HubTypeId: number;
    Budget: number;
}


export class ProjectFormRevision {
    FormId: number;
    RequestDate: string;
    StatusId: number;
    Reason: string;
}

export class CombinedProjectForm {
    ProjectForm: ProjectForm;
    Hubs: ProjectFormHub[];
    Revisions: ProjectFormRevision[];
}

export class DataTableProjectForm {
    FormId: number;
    Email: string;
    StatusId: number;
    SubmissionDate: string;
    RevisionDate: string;

    LeadHub: string;
    DisplayName: string;
    DisplayStatus: string;
    DisplayId: string;
    Button: string;

    initialize(form: CombinedProjectForm, isAdmin: boolean, userEmail: string, isSO: boolean, isPO: boolean): void {
        let statusArray = ["Draft", "Submitted", "Revision Requested", "SO Approved", "Rejected", "PO Approved"];

        let hubArray = ["CA MEPS for HIV / STI / SUD Prevention Research with Reentry Populations",
                        "DEST2nation: A Decentralized, Status neutral, Stakeholder - engaged, post - incarceration intervention for people with and at risk for HIV",
                        "Massachusetts HIV and Justice - Involved Populations Research Network",
                        "NOTRE: Optimizing Long - acting Pre - exposure Prophylaxis and Medications for Opioid Use Disorder Interventions in Carceral Settings",
                        "Project SHIELD: Police Education to Support Public Health in Kentucky",
                        "STOP(Shared decision making to Treat Or Prevent) HIV in Justice Populations",
                        "TechMPower: Advancing HIV / SUD Care and Service Delivery for People Involved in the Criminal Legal System",
                        "SHARE: Substance Use and HIV Action for Reentry and Engagement",
        ];

        let shortenedHubArray = ["CA MEPS",
                                 "DEST2nation",
                                 "MA HIV",
                                 "NOTRE",
                                 "Project SHIELD",
                                 "STOP HIV",
                                 "TechMPower",
                                 "SHARE",
        ];

        this.FormId = form.ProjectForm.FormId;
        this.Email = form.ProjectForm.Email;
        this.StatusId = form.ProjectForm.StatusId;
        this.SubmissionDate = form.ProjectForm.SubmissionDate.split("T")[0];
        this.RevisionDate = form.Revisions.length > 0 ? form.Revisions[form.Revisions.length-1].RequestDate.split("T")[0] : "";

        const hubId = form.Hubs.find(h => h.HubTypeId === 1).HubId
        this.LeadHub = shortenedHubArray[hubId - 1];
        this.DisplayName = form.ProjectForm.Email.split("|")[1];
        this.DisplayStatus = statusArray[form.ProjectForm.StatusId];
        let buttonText = "";

        this.DisplayId = this.FormId.toString();
        for(let i = this.DisplayId.length; i < 3; i++) {
            this.DisplayId = "0" + this.DisplayId;
        }
        this.DisplayId = "P" + this.DisplayId;

        if (this.StatusId === 0) {
            buttonText = "Continue";
        }
        else if (this.StatusId === 2) {
            buttonText = "Review";
        }
        else {
            buttonText = "View";
        }

        if ((isAdmin || isSO || isPO) && this.Email != userEmail) {
            if (this.StatusId == 1 && isSO) {
                buttonText = "Review";
            }
            else if (this.StatusId == 3 && isPO) {
                buttonText = "Review";
            }
            else {
                buttonText = "View";
            }
        }
        this.Button = `<a href="/secure/project-form/project-form?formId=${this.FormId}" class="btn btn-outline-primary no-focus no-decor font-size11 table-button">${buttonText}</a>`;
    }
}




export class UserEmailListing {

    FirstName: string;
    LastName: string;
    Email: string;
    ResearchHub: string;
    Role: string;
    Institution: string;
    CONNECT_Workgroup: string[];


    SortName: string;
    DisplayName: string;


    initialize(): void {
        this.DisplayName = this.FirstName + " " + this.LastName;
        if (this.LastName == "Brinkley-Rubinstein") {
            this.ResearchHub = "INTERACT Center | " + this.ResearchHub;
        }
        this.DisplayName = FormatStringByWordLength(this.DisplayName, 4);
        this.SortName = this.LastName + " " + this.FirstName;
    }
}